import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { Card } from '../components/ui/Card';
import { Archive, Droplets, PackageCheck, Truck } from 'lucide-react';
export function DepotDashboard() {
  const {
    getOrdersByStatus
  } = useOrders();
  const navigate = useNavigate();
  // Counts for dashboard
  const toReceive = getOrdersByStatus('COLLECTEE').length;
  const toClean = getOrdersByStatus('RECUE_DEPOT').length + getOrdersByStatus('ATTENTE_NETTOYAGE').length;
  const toStore = getOrdersByStatus('NETTOYAGE_TERMINE').length;
  const readyForDelivery = getOrdersByStatus('STOCKEE_LIVRAISON').length;
  const dashboardCards = [{
    title: 'Réception',
    count: toReceive,
    icon: Archive,
    color: 'bg-blue-500',
    path: '/depot/reception',
    desc: 'Commandes collectées à scanner'
  }, {
    title: 'Nettoyage',
    count: toClean,
    icon: Droplets,
    color: 'bg-cyan-500',
    path: '/depot/cleaning',
    desc: 'En attente ou en cours'
  }, {
    title: 'Stockage',
    count: toStore,
    icon: PackageCheck,
    color: 'bg-purple-500',
    path: '/depot/storage',
    desc: 'À ranger pour livraison'
  }, {
    title: 'Prêt à livrer',
    count: readyForDelivery,
    icon: Truck,
    color: 'bg-green-500',
    path: '/orders?status=STOCKEE_LIVRAISON',
    desc: 'En attente de tournée'
  }];
  return <div className="space-y-6" data-id="element-377">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-378">
        Tableau de bord Dépôt
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-379">
        {dashboardCards.map(card => <div key={card.title} onClick={() => navigate(card.path)} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow cursor-pointer" data-id="element-380">
            <div className="p-6 flex items-start justify-between" data-id="element-381">
              <div data-id="element-382">
                <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-383">
                  {card.title}
                </p>
                <h3 className="text-3xl font-bold text-gray-900" data-id="element-384">
                  {card.count}
                </h3>
                <p className="text-sm text-gray-400 mt-2" data-id="element-385">{card.desc}</p>
              </div>
              <div className={`p-3 rounded-lg ${card.color} text-white`} data-id="element-386">
                <card.icon className="w-6 h-6" data-id="element-387" />
              </div>
            </div>
            <div className="bg-gray-50 px-6 py-3 border-t border-gray-100 flex items-center text-sm font-medium text-blue-600" data-id="element-388">
              Gérer la file d'attente &rarr;
            </div>
          </div>)}
      </div>

      <div className="mt-8" data-id="element-389">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-390">
          Vue d'ensemble du flux
        </h2>
        <div className="relative" data-id="element-391">
          <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-392">
            <div className="w-full border-t border-gray-200" data-id="element-393" />
          </div>
          <div className="relative flex justify-between" data-id="element-394">
            {['Réception', 'Nettoyage', 'Stockage', 'Livraison'].map((step, idx) => <div key={step} className="bg-white px-2" data-id="element-395">
                  <span className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white text-xs font-bold text-gray-500" data-id="element-396">
                    {idx + 1}
                  </span>
                </div>)}
          </div>
        </div>
      </div>
    </div>;
}